const MODULE_NAME = "CONTACT";
const SET_OPEN = MODULE_NAME + 'SET_OPEN';
const SET_ERROR = MODULE_NAME + 'SET_ERROR';
const SEND_CONTACTFORM_STARTED = MODULE_NAME + 'SEND_STARTED';
const SEND_CONTACTFORM_COMPLETED = MODULE_NAME + 'SEND_COMPLETED';
const SEND_CONTACTFORM_FAILED = MODULE_NAME + 'SEND_FAILED';

export {
  SET_OPEN,
  SET_ERROR,
  SEND_CONTACTFORM_STARTED,
  SEND_CONTACTFORM_COMPLETED,
  SEND_CONTACTFORM_FAILED
};
